import { createAction } from '@reduxjs/toolkit';

export const INIT_UA_CALL_ACTION_TYPE = 'saga/initiateUACall';
export const initiateUACallAction = createAction(INIT_UA_CALL_ACTION_TYPE);
